// import React from "react";
// import "bootstrap/dist/css/bootstrap.css";
// import {Row, Card} from "react-bootstrap";
// import Select from "react-select";
// import axiosConfig from "../config/axiosConfig";
// import BasicTable from '../components/Tables/AdvanceTable';
// import Swal from 'sweetalert2'
// import HeadingBox from '../components/HeadingBox'
// import { Link } from 'react-router-dom'; // Add this line


// const todayDate = new Date();
// const customStyles = {
//   option: (provided, state) => ({
//     ...provided,
//     color: state.isSelected ? "black" : "black",
//     backgroundColor: state.isSelected ? "#7367f0" : "white",
//   }),
//   control: (provided) => ({
//     ...provided,
//     borderRadius: "20px",
//     borderColor: "#7367f0",
//   }),
// };

// const headers = {
//   "Content-Type": "application/json",
//   APIkey: "C5BFF7F0-B4DF-475E-A331-F737424F013C",
// };

// class TrackerReport extends React.Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       Others: "",
//       middleName: "",
//       lastName: "",
//       email: "",
//       mobileNo: "",
//       groups: [],
//       vrnOptions: [],
//       VRNMappingId: "",
//       ActivityId: "",
//       ActivityDate: "",
//       ReminderOdometer: "0",
//       ReminderDate: "",
//       Comments: "",


//       //Added 
//       reportData: [],
//       Emailcolumns: [
//         { "HeaderText": "Vehicle ", "MappingColomn": "regno" },
//         { "HeaderText": "Date Time", "MappingColomn": "reportingDatetime" },
//         { "HeaderText": "Status", "MappingColomn": "vehstatus" },
//         { "HeaderText": "Direction", "MappingColomn": "direction" },
//         { "HeaderText": "Trip ODO", "MappingColomn": "mileage" },
//         { "HeaderText": "Speed", "MappingColomn": "speed" },
//         { "HeaderText": "Location", "MappingColomn": "loc" },
//       ],
//       FromDate:"",
//       ToDate:"",
//     };

//     this.changeGroup = this.changeGroup.bind(this);
//     this.changeHandler = this.changeHandler.bind(this);
//     this.submitHandler = this.submitHandler.bind(this);
//     this.changeVRN = this.changeVRN.bind(this);
//   }

//   componentDidMount() {
//     this.setTodayDate();
//     const data = {
//       UserBranchID: this.props.data.selectedBranchId,
//     };
//     axiosConfig
//       .post("Portal/GetVRNGroupMapping", data)
//       .then((res) => {
//         debugger
//         for (var i = 0; i < res.data.groupVRN.length; i++) {
//           this.setState((prevState) => ({
//             groups: [
//               ...prevState.groups,
//               {
//                 value: res.data.groupVRN[i].groupID,
//                 label: res.data.groupVRN[i].groupName,
//                 vrn: res.data.groupVRN[i].vrnModel,
//               },
//             ],
//           }));
//         }
//       })
//       .catch(function (error) {});
//   }

//   changeGroup(selectedOption) {
//     debugger
//     var tmpArray = [];
//     console.log(tmpArray);

//     this.setState(
//       {
//         vrnOptions: [],
//       },
//       function () {
//         debugger
//         let tmpArray = this.state.groups.find(
//           (groupid) => groupid.value === selectedOption.value
//         );
//         tmpArray.vrn.map((el, index) => {
//           this.setState((prevState) => ({
//             vrnOptions: [
//               ...prevState.vrnOptions,
//               {
//                 value: el.mappingID,
//                 label: el.vrn,
//               },
//             ],
//           }));
//         });
//       }
//     );
//   }
//   async changeVRN(selectedOption) {
//     debugger
//     await this.setState({
//       VRNMappingId: selectedOption.value,
//     });
//   }

//   async setTodayDate() {
//     let year = todayDate.getUTCFullYear();
//     let month = todayDate.getUTCMonth() + 1;
//     if (month < 10) {
//       month = "0" + month;
//     }
//     let day = todayDate.getDate();

//     let _today = year + "-" + month + "-" + day;
//     await this.setState({ mindate: _today });
//   }

//   async submitHandler(e) {
//     /*Added By Ishfaque Kazi on 26th of August  2021*/

//     e.preventDefault();
//     let token = localStorage.getItem("token");
   
//     /*start*/

//     var FromDate = this.state.FromDate.split("T");
//     var ToDate = this.state.ToDate.split("T");

 
//     Swal.fire({
//       title: 'Please Wait ...',
//       onBeforeOpen() {
//           Swal.showLoading()
//       },
//       onAfterClose() {
//           Swal.hideLoading()
//       },
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       allowEnterKey: false,
//       showCancelButton: false,
//       showConfirmButton: false
//   })

//   this.setState({reportData:null})
    
//     axiosConfig.defaults.headers.common['Token'] = token;
//     axiosConfig
//       .post("Portal/TrackerReport", {
//         VRMMappingID: this.state.VRNMappingId,
//         FromDateTime: FromDate[0] + ' ' + FromDate[1],
//         ToDateTime: ToDate[0] + ' ' + ToDate[1],
         
//       })
//       .then((Response) => {
//         this.setState({reportData:Response.data.data})

//         Swal.close();
//       })
//       .catch((error) => {

//         Swal.close();

//         Swal.fire({
//           title: error.response.data.errorMessage,
//           icon: "error",
//           confirmButtonText: "Okay",
//         });

       
//       });
//     /*End*/

    
//   }
//   changeHandler(p) {
//     var newState = {};
//     newState[p.target.name] = p.target.value;
//     this.setState(newState);
//   }

//   render() {
//     const {
//       VRNMappingId,
//       FromDate,
//       ToDate,
//     } = this.state;
//     return (
//       <div >
//         <div style={{ textAlign: 'left', marginLeft: '30px' }}>

// <Link to="/EventAndReports" className="btn btn-shell mr-1 mb-1">Back</Link> {/* Add this line */}

// </div>
//         <Row className="m-0">
//                     <div className="col-md-12 col-12">
//                         <HeadingBox title="You can view this report for a minimum time period of 24 hours and maximum of 36 hours"></HeadingBox>
//                     </div>
//         </Row>
//         <Row className="p-3">
//           <Card className="p-3" style={{ width: "100%" }}>
//             <Card.Title>
//               <div className="pull-left">
//                 Vehicle Movement Report 
//                 <br></br>
//                 <small>{this.state.selectedVehicle}</small>
//               </div>
//             </Card.Title>

//             <Card.Body className="card-content">
//             <div className="form-body"> 
//               <Row>
//                 <div className="col-md-6 col-12" >
//                   <div className="form-group">
//                     {/* <label htmlFor="ReportType">Choose Trend</label> */}
//                     <p className="text-left">Vehicle Group</p>
                    
//                     <Select
//                       className=""
//                       options={this.state.groups}
//                       styles={customStyles}
//                       onChange={this.changeGroup}
//                     ></Select>
//                   </div>
//                 </div>

//                 <div className="col-md-6 col-12">
//                   <div className="form-group">
//                   <p className="text-left">Vehicle</p>
//                     <Select
//                       className=""
//                       options={this.state.vrnOptions}
//                       styles={customStyles}
//                       onChange={this.changeVRN}
//                     ></Select>
//                   </div>
//                 </div>

//                 <div className="col-md-6 col-12">
//                   <div className="form-label-group">
//                   <h7 className="pull-left">From Date</h7>
//                     <input
//                       type="datetime-local"
//                       id="FromDate"
//                       name="FromDate"
//                       value={this.state.FromDate}
//                       onChange={this.changeHandler}
//                       className="form-control"
//                     />
                    
//                   </div>
//                 </div>


//                 <div className="col-md-6 col-12">
//                   <div className="form-label-group">
//                   <h7 className="pull-left">To Date</h7>
//                     <input
//                       type="datetime-local"
//                       id="ToDate"
//                       name="ToDate"
//                       value={this.state.ToDate}
//                       onChange={this.changeHandler}
//                       className="form-control"
//                     />
//                   </div>
//                 </div>
//               </Row>
//               <Row>
//                 <div
//                   className="col-md-12 col-12"
//                   style={{ textAlign: "center", marginTop: "8px" }}
//                 >
//                   <button
//                     type="submit"
//                     className="btn btn-shell mr-1 mb-1"
//                     onClick={this.submitHandler}
//                   >
//                     Generate Report
//                   </button>
//                 </div>
//               </Row>

//               <div className="row">
//                                                 <div className="col-md-12 col-12">
//                 <div className="col-md-12 col-12">
//                   <BasicTable
//                     data={this.state.reportData}
//                     columns={this.state.Emailcolumns}
//                   ></BasicTable>
//                 </div>
//                 </div>
//                 </div>
//               </div>

//               <br></br>
//               <br></br>
//               <br></br>
//               <br></br>
//             </Card.Body>
//           </Card>
//         </Row>
//       </div>
//     );
//   }
// }

// export default TrackerReport;


import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Row, Card } from "react-bootstrap";
import Select from "react-select";
import axiosConfig from "../config/axiosConfig";
import BasicTable from '../components/Tables/AdvanceTable';
import Swal from 'sweetalert2'
import HeadingBox from '../components/HeadingBox'
import { Link } from 'react-router-dom';

const todayDate = new Date();
const currentHours = todayDate.getHours();

if (currentHours < 5) { // AM hours
  todayDate.setDate(todayDate.getDate() + 1); // Add one day
}

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "black" : "black",
    backgroundColor: state.isSelected ? "#7367f0" : "white",
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "20px",
    borderColor: "#7367f0",
  }),
};

const headers = {
  "Content-Type": "application/json",
  APIkey: "C5BFF7F0-B4DF-475E-A331-F737424F013C",
};

const TrackerReport = (props) => {
  const currentDate = new Date();
  const currentHours = currentDate.getHours();

if (currentHours < 5) { // AM hours
  currentDate.setDate(currentDate.getDate() + 1); // Add one day
}

  const tomorrowDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
  const [Others, setOthers] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [groups, setGroups] = useState([]);
  const [vrnOptions, setVrnOptions] = useState([]);
  const [VRNMappingId, setVRNMappingId] = useState("");
  const [ActivityId, setActivityId] = useState("");
  const [ActivityDate, setActivityDate] = useState("");
  const [ReminderOdometer, setReminderOdometer] = useState("0");
  const [ReminderDate, setReminderDate] = useState("");
  const [Comments, setComments] = useState("");

  const [reportData, setReportData] = useState([]);
  const [Emailcolumns, setEmailColumns] = useState([
    { "HeaderText": "Vehicle ", "MappingColomn": "regno" },
    { "HeaderText": "Date Time", "MappingColomn": "reportingDatetime" },
    { "HeaderText": "Status", "MappingColomn": "vehstatus" },
    { "HeaderText": "Direction", "MappingColomn": "direction" },
    { "HeaderText": "Trip ODO", "MappingColomn": "mileage" },
    { "HeaderText": "Speed", "MappingColomn": "speed" },
    { "HeaderText": "Location", "MappingColomn": "loc" },
    { "HeaderText": "Latitude", "MappingColomn": "lat" },
    { "HeaderText": "Longitude", "MappingColomn": "lng" },
  ]);

  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState(""); // Add selectedVehicle state

  useEffect(() => {
    setTodayDate();
    const data = {
      UserBranchID: props.data.selectedBranchId,
    };
    axiosConfig
      .post("Portal/GetAllVRNList", data)
      .then((res) => {
        const tmpVrnOptions = res.data.vrnlist.map((el) => ({
          // value: group.groupID,
          // label: group.groupName,
          // vrn: group.vrnModel,
          value: el.id,
      label: el.vrn,
        }));
        // setGroups(tmpGroups);
        setVrnOptions(tmpVrnOptions);
      })
      .catch(function (error) {});
  }, []);

  // const changeGroup = (selectedOption) => {
  //   debugger
  //   const tmpGroup = groups.find((groupid) => groupid.value === selectedOption.value);
  //   const tmpVrnOptions = tmpGroup.vrn.map((el) => ({
  //     value: el.mappingID,
  //     label: el.vrn,
  //   }));
    // setVrnOptions(tmpVrnOptions);
  // };

  const changeVRN = (selectedOption) => {
    setVRNMappingId(selectedOption.value);
  };

  const setTodayDate = () => {
    let year = todayDate.getUTCFullYear();
    let month = todayDate.getUTCMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    let day = todayDate.getDate();

    let _today = year + "-" + month + "-" + day;
    setFromDate(_today);
  };

  // const submitHandler = (e) => {
  //   e.preventDefault();
  //   let token = localStorage.getItem("token");

  //   var FromDateArr = FromDate.split("T");
  //   var ToDateArr = ToDate.split("T");

  //   Swal.fire({
  //     title: 'Please Wait ...',
  //     onBeforeOpen() {
  //       Swal.showLoading()
  //     },
  //     onAfterClose() {
  //       Swal.hideLoading()
  //     },
  //     allowOutsideClick: false,
  //     allowEscapeKey: false,
  //     allowEnterKey: false,
  //     showCancelButton: false,
  //     showConfirmButton: false
  //   });

  //   debugger

  //   setReportData(null);

  //   axiosConfig.defaults.headers.common['Token'] = token;
  //   axiosConfig
  //     .post("Portal/TrackerReport", {
  //       VRMMappingID: VRNMappingId,
  //       FromDateTime: FromDateArr[0] + ' ' + FromDateArr[1],
  //       ToDateTime: ToDateArr[0] + ' ' + ToDateArr[1],

  //     })
  //     .then((Response) => {
  //       setReportData(Response.data.data);
  //       Swal.close();
  //     })
  //     .catch((error) => {
  //       Swal.close();
  //       Swal.fire({
  //         title: error.response.data.errorMessage,
  //         icon: "error",
  //         confirmButtonText: "Okay",
  //       });
  //     });
  // };

  // Inside your component function
const submitHandler = (e) => {
     debugger
     e.preventDefault();
    let token = localStorage.getItem("token");

  var FromDateArr = FromDate.split("T");
  var ToDateArr = ToDate.split("T");

  // Calculate the duration in milliseconds
  const fromDate = new Date(FromDateArr[0] + ' ' + FromDateArr[1]);
  const toDate = new Date(ToDateArr[0] + ' ' + ToDateArr[1]);
  const durationInMilliseconds = toDate - fromDate;

  // Calculate the duration in hours
  const durationInHours = durationInMilliseconds / (1000 * 60 * 60);
  //check if VRNMappingId is empty
  if(VRNMappingId != "")
  {
  // Check if the duration is within the specified range (24 to 36 hours)
  if (durationInHours <= 36) {
      Swal.fire({
      title: 'Please Wait ...',
      onBeforeOpen() {
        Swal.showLoading()
      },
      onAfterClose() {
        Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false
    });

    setReportData(null);

    axiosConfig.defaults.headers.common['Token'] = token;
    axiosConfig
      .post("Portal/TrackerReport", {
        VRMMappingID: VRNMappingId,
        FromDateTime: FromDateArr[0] + ' ' + FromDateArr[1],
        ToDateTime: ToDateArr[0] + ' ' + ToDateArr[1],
      })
      .then((Response) => {
        setReportData(Response.data.data);
        Swal.close();
      })
      .catch((error) => {
        Swal.close();
        Swal.fire({
          title: error.response.data.errorMessage,
          icon: "error",
          confirmButtonText: "Okay",
        });
      });
  } else {
    // Display an error message or notification for invalid duration
    Swal.fire({
      title: 'Invalid Duration',
      text: 'Please select a duration less than 36 hours.',
      icon: 'error',
      confirmButtonText: 'Okay',
    });
  }
}
else
{
  // Display an error message or notification for not selecting VRNMappingId
  Swal.fire({
    title: 'Vehicle is required',
    text: 'Please select Vehicle',
    icon: 'error',
    confirmButtonText: 'Okay',
  });
}
};


  const changeHandler = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "Others":
        setOthers(value);
        break;
      case "middleName":
        setMiddleName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "mobileNo":
        setMobileNo(value);
        break;
      case "VRNMappingId":
        setVRNMappingId(value);
        break;
      case "ActivityId":
        setActivityId(value);
        break;
      case "ActivityDate":
        setActivityDate(value);
        break;
      case "ReminderOdometer":
        setReminderOdometer(value);
        break;
      case "ReminderDate":
        setReminderDate(value);
        break;
      case "Comments":
        setComments(value);
        break;
      case "FromDate":
        setFromDate(value);
        break;
      case "ToDate":
        setToDate(value);
        break;
      case "selectedVehicle":
        setSelectedVehicle(value);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <div style={{ textAlign: 'left', marginLeft: '30px' }}>
        <Link to="/EventAndReports" className="btn btn-shell mr-1 mb-1">Back</Link>
      </div>
      <Row className="m-0">
        <div className="col-md-12 col-12">
          <HeadingBox title="You can view this report for a maximum period of 36 hours" />
        </div>
      </Row>
      <Row className="p-3">
        <Card className="p-3" style={{ width: "100%" }}>
          <Card.Title>
            <div className="pull-left">
              Vehicle Movement Report
              <br />
              <small>{selectedVehicle}</small>
            </div>
          </Card.Title>

          <Card.Body className="card-content">
            <div className="form-body">
              <Row>
                {/* <div className="col-md-6 col-12">
                  <div className="form-group">
                    <p className="text-left">Vehicle Group</p>
                    <Select
                      className=""
                      options={groups}
                      styles={customStyles}
                      onChange={changeGroup}
                    />
                  </div>
                </div> */}
              
                <div className="col-md-6 col-12">
                  <div className="form-group">
                    <p className="text-left">Vehicle</p>
                    <Select
                      className=""
                      options={vrnOptions}
                      styles={customStyles}
                      onChange={changeVRN}
                    />
                  </div>
                </div>
              </Row>
              <Row>
                <div className="col-md-6 col-12">
                  <div className="form-label-group">
                    <h6 className="pull-left" >From Date</h6>
                    <input
                      type="datetime-local"
                      id="FromDate"
                      name="FromDate"
                      value={FromDate}
                      onChange={changeHandler}
                      className="form-control"
                      onKeyDown={(e) => e.preventDefault()}
                      max={`${new Date(currentDate.getTime()).toISOString().substring(0, 10)}T23:59`}
                      //{`${new Date(new Date(currentDate).getTime()).toISOString().substring(0, 10)}T23:59`}


                    />
                  </div>
                </div>

                <div className="col-md-6 col-12">
                  <div className="form-label-group">
                    <h6 className="pull-left">To Date</h6>
                    <input
                      type="datetime-local"
                      id="ToDate"
                      name="ToDate"
                      value={ToDate}
                      onChange={changeHandler}
                      className="form-control"
                      onKeyDown={(e) => e.preventDefault()}
                      min={FromDate} // Min date is "From Date"
                      max={`${new Date(currentDate.getTime()).toISOString().substring(0, 10)}T23:59`}

                      //max={`${new Date(new Date(currentDate).getTime()).toISOString().substring(0, 10)}T23:59`}


                      />
                 
                  </div>
                </div>
              </Row>
              <Row>
                <div
                  className="col-md-12 col-12"
                  style={{ textAlign: "center", marginTop: "8px" }}
                >
                  <button
                    type="submit"
                    className="btn btn-shell mr-1 mb-1"
                    onClick={submitHandler}
                  >
                    Generate Report
                  </button>
                </div>
              </Row>

              <div className="row">
                <div className="col-md-12 col-12">
                  <div className="col-md-12 col-12">
                    <BasicTable
                      data={reportData}
                      columns={Emailcolumns}
                    />
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />
            <br />
            <br />
          </Card.Body>
        </Card>
      </Row>
    </div>
  );
};

export default TrackerReport;
